<!-- =========================================================================================
  File Name: DataViewSidebar.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
        <h4>{{ Object.entries(this.data).length === 0 ? "ADD NEW" : "EDIT" }} TICKET </h4>
        <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <component :is="scrollbarTag" class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">

      <div class="p-6">
        <!-- NAME -->
        <vs-input  label="Name *" v-model="dataName" class="mt-5 w-full" name="name" v-validate="'required'" maxlength="150"/>
        <span class="text-danger text-sm" v-show="errors.has('name')">{{ errors.first('name') }}</span><br>
        <label class="vs-select--label w-full">Description *</label>
         <vs-textarea label="" v-model="dataDetail" name="description" v-validate="'required'" maxlength="190"/>
        <label class="vs-select--label w-full">Category *</label>
        <v-select  label="name"   :closeOnSelect="true" v-model="dataCategory"  :options="categories"  /><br>
        <label class="vs-select--label w-full" v-if="hasRole">Status *</label>
        <v-select  label="name" v-if="hasRole"  :closeOnSelect="true" v-model="dataStatus"  :options="statuses"  /><br>
        <span v-if="!dataId" :id="'div-with-'" class="vs-con-loading__container flex" :ref="'div-with-'">
          <label for="">File Attachment (optional)</label>
         <input   type="file" multiple  ref="file"   @change="uploadFile()" accept=".gif,.jpg,.jpeg,.png,.doc,.docx,.ppt,.csv,.txt,.bmp,.pdf" >
        </span>
        <br>
             <span v-for="(file, index ) in uplodedfiles" :key="index">
              <vs-chip  @click="removefile(index)"  closable class="leading-none font-medium">{{file.orignal}}</vs-chip>
            </span> <br><br>
            <span v-if="largeFile.length>0" class="text-danger text-sm">Large Files</span><br>
             <ul v-for="(file, i ) in largeFile" :key="i">
               <li>
                 <vs-chip class="leading-none font-medium">{{file}}</vs-chip>
                </li>
            </ul>
        <!-- <label class="vs-select--label w-full">Comment *</label>
         <vs-textarea label="" v-model="dataComment" name="comment" v-validate="'required'"/> -->
      </div>
    </component>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click.native="submitData" :disabled="!isFormValid">Submit</vs-button>
      <vs-button type="border" color="danger" @click.native="isSidebarActiveLocal = false">Cancel</vs-button>
    </div>
  </vs-sidebar>
</template>


<script>
import Datepicker from 'vuejs-datepicker'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import vSelect from 'vue-select'
import moment from 'moment'
import {CREATE_TICKET, UPDATE_TICKET} from '@/graphql'
import {ALL_TICKET_CATEGORIES, ALL_TICKET_STATUSES, UPLOAD_FILE, FILTER_TICKET_STATUSES } from '@/graphql'
import S3 from 'aws-s3'
const config = {
  bucketName: process.env.VUE_APP_AWS_BUCKET,
  dirName: process.env.VUE_APP_AWS_DIREC,
  region: process.env.VUE_APP_AWS_DEFAULT_REGION,
  accessKeyId: process.env.VUE_APP_AWS_ACCESS_KEY_ID,
  secretAccessKey: process.env.VUE_APP_AWS_SECRET_ACCESS_KEY,
  s3Url: process.env.VUE_APP_AWS_s3Url
}
const S3Client = new S3(config)
export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    VuePerfectScrollbar,
    'v-select': vSelect,
    Datepicker,
    moment
  },
  data () {
    return {
      dataId:'',
      dataName:'',
      dataDetail:'',
      dataStatus:{ 'id': '1', 'name': 'Pending', 'color': 'danger', '__typename': 'StatusPayload' },
      dataCategory:'',
      meID:'',
      meRole:'',
      categories:[],
      statuses:[],
      uplodedfiles:[],
      largeFile:[],
      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      },
      userRolePermissions: [],
      hasRole: false
    }
  },
  watch: {
    isSidebarActive (val) {
      if (!val) return
      if (Object.entries(this.data).length === 0) {
        this.initValues()
        this.$validator.reset()
      } else {
        const {id, name, description, status, category} = JSON.parse(JSON.stringify(this.data))
        this.dataId = id
        this.dataName = name
        this.dataDetail = description
        this.dataCategory = category
        this.dataStatus = status
        this.initValues()
      }
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get () {
        return this.isSidebarActive
      },
      set (val) {
        if (!val) {
          this.$emit('closeSidebar')
          this.$validator.reset()
          this.initValues()
        }
      }
    },
    isFormValid () {
      return !this.errors.any() && this.dataName && this.dataDetail && this.dataCategory && this.dataStatus
    },
    scrollbarTag () { return this.$store.getters.scrollbarTag }
  },
  methods: {
    sizemessage (index) {
      this.$vs.notify({
        title: 'Incident',
        text: `File ${index + 1} is too Large!`,
        color: 'danger',
        position: 'top-right'
      })
    },
    removefile (file) {
      this.uplodedfiles.splice(file, 1)
    },
    openLoadingInDiv () {
      this.$vs.loading({
        type:'sound',
        container: '#div-with-',
        scale: 0.6
      })
    },
    uploadFile () {
      const largeFile = []
      for (let i = 0; i < this.$refs.file.files.length; i++) {
        const limit = 1024 * 1024 * 2048
        if (this.$refs.file.files[i].size > limit) {
          largeFile.push(this.$refs.file.files[i].name)
        } else {
          const file = this.$refs.file.files[i]
          const orignal_name = this.$refs.file.files[i].name
          const name = Math.random().toString().slice(2)
          this.openLoadingInDiv()
          S3Client.uploadFile(file, name)
            .then(response => {
              this.$vs.loading.close('#div-with- > .con-vs-loading')
              this.SaveFile(response, orignal_name)
            })
            .catch(err => console.error(err))

        }
      }
      this.largeFile = largeFile


      // var largeFile=[]
      // this.openLoadingInDiv();
      // let formData=[];
      // for( var i = 0; i < this.$refs.file.files.length; i++ ){
      //     let limit = 1024 * 1024 * 2048;
      //       if(this.$refs.file.files[i].size > limit){
      //         largeFile.push(this.$refs.file.files[i].name)
      //       }
      //       else{
      //         let file = this.$refs.file.files[i];
      //         formData.push(file);
      //       }
      //       this.largeFile=largeFile

      // }
      //       this.$apollo
      //         .mutate({
      //           mutation: UPLOAD_FILE,
      //           variables: {
      //             file: formData,
      //           }
      //         })
      //         .then(response => {
      //           if (response) {
      //             var files=response.data.uploadFile.files
      //             for (let i = 0; i < files.length; i++) {
      //               this.uplodedfiles.push(files[i])

    //             }
    //             this.$vs.loading.close(`#div-with- > .con-vs-loading`)
    //           }
    //         }).catch(error => {
    //         console.log(error)
    //       });
    },
    SaveFile (response, orignal_name) {

      if (response) {
        this.uplodedfiles.push({
          'orignal':orignal_name,
          'new':response.key,
          'link':response.location
        })
      }

    },
    StatusSuccess () {
      this.$emit('getdata', true)
      this.$vs.notify({
        title: 'Ticket',
        text: 'Added Successfully!',
        color: 'success',
        position: 'top-right'
      })
    },
    initValues () {
      if (this.data.id) return
      this.dataId = null
      this.dataName = ''
      this.dataDetail = ''
      this.dataCategory = ''
      this.dataStatus = { 'id': '1', 'name': 'Pending', 'color': 'danger', '__typename': 'StatusPayload' }
      this.uplodedfiles=[]
      this.largeFile=[]
      this.$refs.file.value=''
    },
    submitData () {
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.dataId !== null && this.dataId >= 0) {
            this.$apollo
              .mutate({
                mutation: UPDATE_TICKET,
                variables: {
                  id:this.dataId,
                  name:this.dataName,
                  description:this.dataDetail,
                  status: this.dataStatus.id,
                  category: this.dataCategory.id,
                  updated_by:this.meID
                }
              })
              .then(response => {
                if (response.data.updateTicket.status == 'SUCCESS') {
                  this.$emit('closeSidebar')
                  this.initValues()
                  this.StatusSuccess('Update')
                }

              }).catch(error => {
                console.log(error)
              })


          } else {
            this.$apollo
              .mutate({
                mutation: CREATE_TICKET,
                variables: {
                  name:this.dataName,
                  description:this.dataDetail,
                  status: this.dataStatus.id,
                  category: this.dataCategory.id,
                  created_by:this.meID,
                  files:this.uplodedfiles
                }
              })
              .then(response => {
                if (response.data.createTicket.status == 'SUCCESS') {
                  this.uplodedfiles = []
                  this.$refs.file.value = null
                  this.$emit('closeSidebar')
                  this.initValues()
                  this.StatusSuccess('Add')
                }

              }).catch(error => {
                console.log(error)
              })
          }
        }
      })
    }
  },
  created () {
   
      this.meID = localStorage.getItem('userId');
      let userRole = JSON.parse(localStorage.getItem('userRoles'))
      this.meRole = userRole[0].name
      this.userRolePermissions= userRole[0].permissions
      
        const exists = this.userRolePermissions.some(function (permission) {
          return permission.name === 'edit_tickets'
        })
        if (exists) {
          this.hasRole = true
        } else {
          this.hasRole = false

        }

    this.$apollo
      .mutate({
        mutation: ALL_TICKET_CATEGORIES
      })
      .then(response => {
        this.categories = response.data.ticketCategories
      })
    this.$apollo
      .query({
        query: FILTER_TICKET_STATUSES
      })
      .then(response => {
        this.statuses = response.data.filterTicketStatuses
      })


  }
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

    &:not(.ps) {
      overflow-y: auto;
    }

}
</style>
